@if (colorFamily()) {
  <div
    class="color-item"
    (mouseenter)="showSelector = true"
    (mouseleave)="showSelector = false"
    (mousedown)="onColorFamilyClick()">
    <div class="color-item-content" ppgBackground [imageUrl]="colorFamily().imageUrl" [rgb]="colorFamily().rgb">
      <div
        [attr.data-test-id]="'colorFamilies.selectorOf' + colorFamily().name"
        class="color-item-main-content"
        ppgFontColorBasedOnBackground
        [backgroundRGB]="colorFamily().rgb">
        {{ colorFamily().name }}
      </div>
    </div>
    @if (this.isSelected() || showSelector) {
      <div data-test-id="colorFamilies.activeSelector" class="selector"></div>
    }
  </div>
}
